module.exports = __webpack_public_path__ + "img/CREST-TC.5def293f.png";